import EmptyLayout from "./EmptyLayout";

export default EmptyLayout;